export default {
  nullData: '暂无',
  look: '查看',
  operation: '操作',
  delete: '删除',
  cancel: '取消',
  edit: '编辑',
  sure: '确定',
  query: '查询',
  unknown: '未知',
  other: '其他',
  purchaser: '采购商',//{{$t('purchaser')}}  this.$t('purchaser')
  supplier: '供应商',//{{$t('supplier')}}  this.$t('supplier')
  close: '关闭',
  type: '类型',
  keyWord: '产品关键词',//{{$t('keyWord')}}  this.$t('keyWord')
  hsCode: 'HS编码',//{{$t('hsCode')}} this.$t('hsCode')
  companyName: '公司名称',//{{$t('companyName')}} this.$t('companyName')
  countryorRegion: '国家/地区',
  phone: '电话',
  email: '邮箱',
  fax: '传真',
  media: '社媒',
  amount: '金额', //{{$t('companyName')}} this.$t('amount')
  download: '下载',
  chinese: '中文',
  english: '英文',
  export: '导出',
  tips: '提示',
  Unsubscribe: '取消订阅',
  subscribedOver: '已订阅',
  subscribe: '订阅',
  add: '新增',
  addTo: '添加',//{{$t('addTo')}}
  enterprise: '企业',
  address: '地址',
  more: '更多',
  translate: '翻译',
  enter: '输入',
  submit: '提交',
  brand: '品牌',//{{$t('brand')}}
  autoTranslate: '自动翻译',
  back: '返回',//{{$t('back')}}
  save:'保存',
  topeaseVip:'特易会员您好：',
  topeasePro:'特易产品部',
  message: {
    weChatSucess: '微信绑定成功',
    notExist: '您访问的网页不存在',
    loading: '加载中',
    jumping: '跳转中请稍等',
    noPermission: '本账号无权限访问此国家数据。', //this.$t('message.noPermission')
    noData: '暂无数据',
    changeSucess: '切换语言成功',
    ConsolidatedEnterprise:'解散成功,(如您正在解散的合并企业是您的【已关注】企业，当您解散合并此企业时，此企业将会从您的关注企业列表中被移除。)',
    prompt:{
      enterOpportunityList:'商机列表名',//this.$t('message.prompt.enterOpportunityList')
      cannotEmpty:'输入内容不能为空',//this.$t('message.prompt.cannotEmpty')
      opportunityListName:'商机列表名',//this.$t('message.prompt.opportunityListName')
      pleaseEnter:'请输入'//this.$t('message.prompt.pleaseEnter') :placeholder="$t('message.prompt.pleaseEnter')"
    },
    confirm:{
      wantLogout:'您要退出登录吗？',//this.$t('message.confirm.wantLogout')
      cancelOpportunityList:'您正在删除商机列表，该商机列表的订阅功能也将自动被关闭，请确认是否继续？',//this.$t('message.confirm.cancelOpportunityList')
      cancelFollow:'您正在取消关注，系统将自动关闭对此企业的订阅与独享，请确认是否继续？',//this.$t('message.confirm.cancelFollow')
      delectExport:'此操作将删除该导出企业记录，是否继续？',//this.$t('message.confirm.delectExport')
      delectTradeData:'此操作将删除该交易数据下载记录，是否继续？',//this.$t('message.confirm.delectTradeData')
      actionWill:'此操作将',//this.$t('message.confirm.actionWill')
      exclusiveEnterprise:'独享该企业，是否继续？',//this.$t('message.confirm.exclusiveEnterprise')
      cancelEnterprise:'此操作将取消关注选中企业，是否继续？',//this.$t('message.confirm.cancelEnterprise')
      deleteContact:'您正在删除从「易搜邮」中挖掘到的联系人，系统会删除同一批次挖掘结果中的所有联系人，请确认您的操作。',//this.$t('message.confirm.deleteContact')
      dataChange:'此操作将数据纠错, 是否确定？',//this.$t('message.confirm.dataChange')
      importEmail:'此操作将选中企业导入易搜邮，是否继续？',//this.$t('message.confirm.importEmail')
      deleteProduct:'此操作将删除该产品分析 是否继续？',//this.$t('message.confirm.deleteProduct') 
      deleteHistory:'此操作将删除该历史搜索记录, 是否继续？', //this.$t('message.confirm.deleteHistory')
      deleteThis:'此操作将删除该',//this.$t('message.confirm.deleteThis')
      productTag:'产品数据标签',//this.$t('message.confirm.productTag')
      smartOpportunities: '商机',//this.$t('message.confirm.smartOpportunities')
      isContinue:'，是否继续?',//this.$t('message.confirm.isContinue')
    },
    
    warning:{
      fileDeleted: '文件已删除',
      selectFile: '请选择文件',//this.$t('message.warning.selectEnterprise')
      selectEnterprise: '请选择企业',//this.$t('message.warning.selectEnterprise')
      chooseOpportunityList: '请选择商机列表',//this.$t('message.warning.chooseOpportunityList')
      chooseFollowCompanyList: ' 请选择企业',//this.$t('message.warning.chooseFollowCompanyList')
      notEmpty:'不能为空',//this.$t('message.warning.notEmpty')
      valueHo:'填写值要大于0',//this.$t('message.warning.valueHo')
      sectionValue:'请填写需要区间值。',//this.$t('message.warning.sectionValue')
      chooseSpecificC:'请选择具体国家下载。',//this.$t('message.warning.chooseSpecificC')
      noPermission:'本账号无权限。',//this.$t('message.warning.noPermission')
      masterEnterprise:'请指定一个主企业',//this.$t('message.warning.masterEnterprise')
      chooseTwoE:'请至少选择两家企业',//this.$t('message.warning.chooseTwoE')
      chooseTradeData:'请选择贸易数据',//this.$t('message.warning.chooseTradeData')
      chooseHScode:'至少输入两位HS编码',//this.$t('message.warning.chooseHScode')
      tranISN:'翻译内容不能为空',//this.$t('message.warning.tranISN')
      enterDes:'请输入商品描述',//this.$t('message.warning.enterDes')
      currentKey:'当前已包含关键词为“',//this.$t('message.warning.currentKey')
      condition:'”的条件',//this.$t('message.warning.condition')
      enterHScode:'请输入HS编码',//this.$t('message.warning.enterHScode')
      enterProductName:'请输入产品关键词',//this.$t('message.warning.enterProductName')
      keyWordHave:'该关键词已存在',//this.$t('message.warning.keyWordHave')
      hsCodeHave:'该HS编码已存在',//this.$t('message.warning.hsCodeHave')
      buyerName:'请输入采购商名称',//this.$t('message.warning.buyerName')
      notifierName:'请输入通知人名称',//this.$t('message.warning.notifierName')
      currentHSCode:'当前已包含HS编码为“',//this.$t('message.warning.currentHSCode')
      enterBrand:'请输入品牌',//this.$t('message.warning.enterBrand')
      brandExists:'该品牌已存在',//this.$t('message.warning.brandExists')
      enterSuppName:'请输入供应商名称',//this.$t('message.warning.enterSuppName')
      enterOriginOut:'请输入原产国(出口国)',//this.$t('message.warning.enterOriginOut')
      enterOriginImport:'请输入原产国(进口国)',//this.$t('message.warning.enterOriginImport')
      originCountryHave:'该原产国(出口国)已存在',//this.$t('message.warning.originCountryHave')
      originCountryImportHave:'该原产国(进口国)已存在',//this.$t('message.warning.originCountryImportHave')
      enterDeparture :'请输入起运港/关区',//this.$t('message.warning.enterDeparture')
      departureHave:'该起运港/关区已存在',//this.$t('message.warning.departureHave')
      enterObjective:'请输入目的港/关区',//this.$t('message.warning.enterObjective')
      objectiveHave:'该目的港/关区已存在',//this.$t('message.warning.objectiveHave')
      contNotNull:'翻译内容不能为空',//this.$t('message.warning.contNotNull')
      Pleasefill:'请填写好搜索信息，再搜索',
      currentcountry:'当前国家错误，请重新切换国家',
    },
    success:{
      deleteSuccess:'删除成功', //this.$t('message.success.deleteSuccess')
      topSuccess:'置顶成功', //this.$t('message.success.topSuccess')
      cancelAttSuccess:'取消关注成功',//this.$t('message.success.cancelAttSuccess')
      modifySuccess:'修改成功',//this.$t('message.success.modifySuccess')
      enjoySuccess:'独享成功',//this.$t('message.success.enjoySuccess')
      closeSuccess:'关闭成功',//this.$t('message.success.closeSuccess')
      subscribeSuccess:'订阅成功',//this.$t('message.success.subscribeSuccess')
      followSuccess:'关注成功',//this.$t('message.success.followSuccess')
      mergeSuccess:'合并企业成功',//this.$t('message.success.mergeSuccess')
      mergeSuccessfollow:'合并企业成功(如您正在合并企业是您的【已关注】的合并企业，当您合并此企业时，此企业将会您的关注企业列表中被移除，请重新关注。)',
      addSuccessLook:'添加成功，您可以在系统的【总览】页面中，查看已经添加的商机列表，并进行编辑或订阅等操作。',//this.$t('message.success.addSuccessLook')
      createdSuccess:'创建成功',//this.$t('message.success.createdSuccess')
      saveSuccess:'保存成功，您可以在系统的【总览】页面中，查看已经添加的商机列表，并进行编辑或订阅等操作。',//this.$t('message.success.saveSuccess')
      addSuccess:'添加成功',//this.$t('message.success.addSuccess')
      saveSuccessOver:'保存成功。',//this.$t('message.success.saveSuccessOver')
      cancelLookSuccess:'取消订阅成功',//this.$t('message.success.cancelLookSuccess')
      custoremTableSuccess:'自定义表格成功',//this.$t('message.success.custoremTableSuccess')
      passwordModifiedSuccess:'密码修改成功',//this.$t('message.success.passwordModifiedSuccess')
      versionSwitchsucceed:'版本切换成功。',//this.$t('message.success.versionSwitchsucceed')
      wechatBindingSucceed:'绑定微信成功',//this.$t('message.success.wechatBindingSucceed')
      HasBeenAddEasySearchEmailContact:'已加为易搜邮联系人'
    },
    rules:{
       enterKeyword:' 请填写产品关键词'//this.$t('message.rules.enterKeyword')
    }
  },
  // components start 
  components: {
    exportitems: {
      selected: '选中的', // {{$t('components.exportitems.selected')}}
      exportQuantity: '导出企业数量',
      tradeNum: '交易数据条数',
      whichContains: '其中包含',
      onceDownloaded: '家曾经下载过的',
      onceTradeDownloaded: '条曾经下载过的',
      notOpen: '暂未开放用户下载，被过滤。',
      chooseDown: '勾选后，在导出的文件中，将不包含历史导出过的',
      tradeDownNum: '交易数据下载条数',
      consumptionNeed: '本次导出需要消耗',
      exportNum: '可导出点数',
      surplus: '剩余',
      currentChoose: '当前所选的',
      downTips: '下载条数',
      beenExceeded: '，已经超出账户剩余',
      ifConfirmed: '，如果确认',
      systemIs: '，系统将仅',
      customNeed: '内的数据；您可以联系系统管理员或者专属客服进行',
      recharge: '充值',
      exportEnterpriseList: '导出企业列表',// {{$t('components.exportitems.exportEnterpriseList')}}
      downloadIntelligence: '下载交易情报',
      enterprise: '企业',
      tradeData: '交易数据',
      point: '点数',
      articles: '条数',
    },
    header: {
      login: '登录', // {{$t('components.header.login')}}
      updateAnnouncement: '更新公告',
      accountCenter: '账户中心',
      LogOut: '退出登录',
    },
    leftFilter: {
      pleaseEnter: '请输入',// {{$t('components.leftFilter.pleaseEnter')}}
      switchLegacy: '名称并回车创建',
      startTime: '开始日期',
      endTime: '结束日期',
      to: '至',
      putAway: '收起',
      expandOptions: '展开全部选项',
      topFloor: '回到顶层',
      collapseFilter: '收起筛选',
      expandFilter: '展开筛选',
      Currentdataperiod:'当前数据源可查询时段',
      lastmonth:'最新一个月',
      lastthreemonths:'最新三个月',
      latestyear:'最新一年',
      lastthreeyears:'最新三年',
    },
    promptInformation: {
      thanks: '如您对此有任何疑问请与客服联系，感谢您的支持！',
      backHome: '返回首页',// {{$t('components.promptInformation.backHome')}}
      previouPage:"返回上一页",// {{$t('components.promptInformation.previouPage')}}
    },
    translate: {
      systemTran: '系统将自动把您输入的关键词翻译成如下语种进行搜索，您也可以点击编辑按钮，对自动翻译的内容进行修正，以保证搜索结果更加精准：',
      surceChange: '确认修改', // {{$t('components.translate.surceChange')}}
    }
  },
  // components end 
  //homes  start
  homes: {
    enterSystem:"进入系统",
    enter: '输入',
    intoCapital: '化资讯为资本',
    search: '搜索...',
    productName: '产品名',//this.$t('homes.productName')
    hsCode: 'HS编码', //this.$t('homes.hsCode')
    companyName: '公司名',//this.$t('homes.companyName')
    allCountry: '全部国家',// {{$t('homes.allCountry')}}  this.$t('homes.allCountry')
    whole: '全部',// {{$t('homes.whole')}}   this.$t('homes.whole')
    global: '全球',// {{$t('homes.global')}}  this.$t('homes.global')
    strength: '综合实力',
    found: '创立于2004年，获大型国有企业东浩兰生集团投资，是商务部国际电子商务中心（CIECC）指定合作伙伴。与邓白氏等全球商业智能与数字化营销企业深度合作已合作多年。已累计帮助中国3万多家外贸企业数字化营销转型与可持续成长，持续推动数据在海外营销和全球商业竞争中的运用。',
    dataResources: '数据资源',
    accumulation: '18年数据积累、包含超过100亿数据量，按金额统计近一年的贸易数据，涵盖了超过全球70%以上可查询的交易情报数据；引入的邓白氏商业数据，以及多国商业名录，包含超过4亿家全球企业信息，涵盖1000+行业背景及深度分析信息，超过5.2亿商业联系人信息，助力外贸企业突破业务瓶颈。',
    technical: '技术能力',
    useData: '- 使用前沿大数据技术框架，对PB级数据进行毫秒级响应处理。<br> - 微服务PaaS平台服务，灵活拓展，SaaS升级产品。<br> - 机器学习算法和人工智能，智能响应前端需求。<br> - 100+服务器，50+数据技术运维团队，稳定无忧。',
    serviceExperience: '服务经验',
    absorbed: '专注于服务外贸企业客户，可信赖的数据顾问全程支持；以客户需求为中心，致力于提供专业，有温度的客户服务；通过成熟的服务体系运营加深客户联结，助力客户在数智时代的新赛道上加速拓展并落地，在应对激烈复杂的全球贸易市场环境中更具竞争力。',
    alldatasources:'全部数据源',
    justlookatthenew:'只看新增',
    Trendchart:'趋势图',
    Piechart:'饼状图',
    Purchaser:'采购商',
    supplier:'供应商',
    businessdirectory:'商业名录',
    businessData:'商业数据',
  },
  //homes  end
  //头部 dashboard start
  header: {
    projectName: '外贸资讯宝GT6.0',
    change: '切换',
    enter: '进入',
    navBar: {
      overView: '总览',
      teeSou: '特易搜搜',
      businessData:'商业数据',
      tradeIntelligence: '贸易情报',
      productAnalysis: '产品分析',
      trendAnalysis: '趋势分析', //{{$t('header.navBar.trendAnalysis')}}
      analysisReport: '市场研究', //{{$t('header.navBar.analysisReport')}}
      userCenter: '用户中心'
    },
  },
  //list
  // List: {
  //   guanzhuyushoucang: '关注与收藏',
  //   shangjiliebiao:'商机列表',
  //   guanzhuqiye:'关注企业',
  //   shoucangtidan:'收藏提单',
  //   shoucangdetidan:'收藏的提单',
  //   benyueleijigengxin:'本月累计更新',
  //   xiazaizhongxin:'下载中心',
  //   xiazaiwenjianzongshu:'下载文件总数',
  //   xiazaijiaoyi:'下载交易',
  //   daochuqiye:'导出企业',
  // },
  //商机列表
  opportunityList: {
    opportunityListTitle: '商机列表',// {{$t('opportunityList.opportunityListTitle')}}
    FocusonEnterprises:'可关注企业数是每个账号或子账号可以关注企业的上限。',
    Exportenterprise:'可导出企业数是您的公司当前剩余的总数量，所有子账号共享当前数量。子账号需要在主账号开启下载权限的情况下使用。',
    Downloadtransaction:'可下载交易数是您的公司当前剩余的总数量，所有子账号共享当前数量。子账号需要在主账号开启下载权限的情况下使用。',
  },
  //账户概况
  accountOverview: {
    accountOverview: '账户概况',
    accountID: '账号ID号',
    affiliatedCompany: '所属公司',
    expirationDate: '到期日期',
    surplus: '剩余',
    day: '天',
    numberOfSubAccounts: '子账号数',
    countriesOpened: '已开通国家',
    customerService: '客服',
    Tel: '电话',
    Mobile: '手机',
    Email: '邮箱',
    Enterprise: '企业微信',
  },
  dashboardCont: {
    childfollow: '子账号关注',
    followandcollect: '关注与收藏',
    businessopportunitylist: '商机列表',
    smartList: '商机列表',
    souLabel: '特易搜搜查询标签',
    followent: '关注企业',
    bookmarkorders: '收藏提单',
    bookmarksorders: '收藏的提单',
    downloadcenter: '下载中心',
    downloadfiles: '下载文件总数',
    downloadtrad: '下载交易',
    exportent: '导出企业',
    monthly: '本月新增',

    focusEnterprises: '关注企业',
    manageEnterprises: '管理子账号关注企业',
    lable: '标签', //{{$t('dashboardCont.lable')}}
    childAbout: '切换为子账户关注',
    backAbout: '回到我的关注',
    address: '地区',
    byWeek:'按周',
    byMonth:'按月',
    byYear:'按年',
    chooseAddress: '请选择地区',
    chooseType: '请选择类型',
    subAccount: '子账号',
    pleaseSelect: '请选择',
    exportRecords: '导出企业记录',
    selectAllList: '全选列表',
    downloadEnterprise: '下载企业',
    downloadRecord: '交易数据下载记录',
    administration: '管理',
    adviceTag: '为了您更方便的区分关注的企业，建议您为关注的公司，添加一个或多个自定义标签，例如用：日期、公司类型、产品名称等。',
    addLable: '添加标签',
    listOrder: '商机列表订阅规则',
    listOrderAbout: '关注企业订阅规则',
    openRead: '开启订阅时，系统将按照下方您设置的规则，定期向您提供邮件或微信通知，从而帮助您更好了解市场。',
    notificationMethod: '通知方式',
    enterContent: '请输入内容',//:placeholder="$t('dashboardCont.enterContent')"
    subscriptionCycle: '订阅周期',
    everyDataChange: '每次数据更新',
    modifySubscription: '修改订阅',
    modifyLabel: '修改标签',
    cancelAttention: '取消关注',
    setPassword: '账户密码设置',
    weclomeLogin: '欢迎您首次登录特易资讯E平台，为了账户安全，请您设置登录密码，并完成开通流程。',
    originalPassword: '原密码:',
    originalPasswordEnter: '请您输原密码',
    loginPassword: '登录密码:',
    loginPasswordRequirement: '请您输入一个8～20位数，字母或数字组成的密码',
    duplicatePassword: '重复密码:',
    passwordSure: '请您再输入一次密码，确认密码的准确性',
    next: '激活，下一步',
    selfTarget: '账户个性化目标',
    selfTargetResult: '您设置的个性化目标，将会对系统推荐的采购商或供应商产生一定的优化，让您获得更佳的查询结果。',
    queryProducts: '主要查询产品:',
    enterKeyword: '请您至少输入一个产品关键词，不限中文或英文',
    interestedCountry: '感兴趣的国家/地区:', //:label="$t('dashboardCont.interestedCountry')"
    countryAdd: '国家/地区:',
    interestedCountryEnter: '请选择感兴趣的国家/地区',//:placeholder="$t('dashboardCont.interestedCountryEnter')"
    sureNext: '确定，下一步',
    useWeChat: '账户绑定微信使用',//{{$t('dashboardCont.useWeChat')}}
    useWeChatOver: '扫描二维码确认绑定之后，即可使用微信登录E平台。如您需要解绑，可前往账户中心，自行解绑，也可以通过公司的主账号进行解绑。',
    scanCode: '刷新微信二维码',
    skip: '跳过',
    productkey: '产品关键词',
  },
  //系统消息
  systemInformation: {
    systemInformation: '系统消息',
  },
  //表格组件 Maintable.vue
  tableComponent: {
    batchOperation: '批量操作',
    intervalDownload: '区间下载',
    analysis: '分析',
    download: '下载',
    search: '输入关键词进行搜索', //this.$t('tableComponent.search')
    total: '共',
    strip: '条',
    goTo:'前往',
    page:'页'
  },
  //表格头部 columns.js
  tableHeader: {
    listName: '列表名称',
    updataTime: '更新时间',
    type: '类型',
    numberOfBuyers: '采购商数量',
    numberOfSuppliers: '供应商数量',
    subscription: '订阅',
    // viewList: '查看列表',
    // downloadListEnterprise: '下载列表企业',
    viewList: '查看',
    downloadListEnterprise: '下载',
    delete: '删除',
    mode: '方式',
    searchContent: '搜索内容',
    searchAgain: '重新搜索',
    enterprisesNum: '企业数量',
    labelName: '标签名称', //this.$t('tableHeader.labelName')
    market: '市场',
    IncreaseAmount: '增长金额',
    growthRatio: '增长比例',
    dataSource: '数据源',
    sourceType: '数据源类型',
    tradeRole: '贸易角色',
    tradePercentage: '交易次数(占比)',
    amount: '金额(USD)',
    contacts: '联系人',
    sourceMode: '数据来源方式',
    position: '职位',
    fax: '传真',
    January: '1月',
    February: '2月',
    March: '3月',
    April: '4月',
    May: '5月',
    June: '6月',
    July: '7月',
    August: '8月',
    September: '9月',
    October: '10月',
    November: '11月',
    December: '12月',
    yearTotal: '年度汇总',
    tradeNum: '交易数(占比)',
    newTradetime: '最新交易时间',
    suppNum: '供应商数量',
    amountNum: '金额(美元)',
    nearlyData: '最新交易时间',
    buyNum: '采购商数量',
    tradeLine: '贸易线路',
    tradTrend: '交易趋势',
    codeDes: '编码描述',
    allAcount: '总金额',
    proportion: '占比情况',
    increaseAmount: '增长金额',
    growthRatio: '增长比例',
    timeSlot: '时间段',
    tradePerson: '贸易伙伴',
    registeredAdd : '注册地址',
    numOne: '第一计量',
    numOneUnit: '第一计量单位',
    numOneUnitPrice: '第一计量均价',
    numTwo: '第二计量',
    numTwoUnit: '第二计量单位',
    numTwoUnitPrice: '第二计量均价',
    absolutData: '贸易差额绝对值',
    differenceType: '差额类型',
    departure: '起运港',//{{$t('tableHeader.departure')}} this.$t('tableHeader.departure')
    countryOrigin: '原产国',//{{$t('tableHeader.countryOrigin')}} this.$t('tableHeader.countryOrigin')
    destinationCountry: '目的国',// this.$t('tableHeader.destinationCountry')
    enterpriseScreening: '企业筛选',//this.$t('tableHeader.enterpriseScreening')
    trade: '交易',
    boxNumT: '箱量(TEU)',
    enterpriseName: '企业名称',
    tradeMonth: '交易月份',
    tradeNumS: '交易次数',//this.$t('tableHeader.tradeNumS')
    mun: '数量',//this.$t('tableHeader.mun')
    weight: '重量',//this.$t('tableHeader.weight')
    boxNum: '箱量',//{{$t('tableHeader.boxNum')}} this.$t('tableHeader.boxNum')
    boxNums: '箱量',//{{$t('tableHeader.boxNums')}} this.$t('tableHeader.boxNums')
    munE: '数量均价',//this.$t('tableHeader.mun')
    weightE: '重量均价',//this.$t('tableHeader.weight')
    boxNumE: '箱量均价',//{{$t('tableHeader.boxNum')}} this.$t('tableHeader.boxNum')
    countryName: '国家/地区名称',
    purchaserName: '采购商名称',//{{$t('tableHeader.purchaserName')}}
    supplierName: '供应商名称',//{{$t('tableHeader.supplierName')}}
    notifierName: '通知人名称',//{{$t('tableHeader.notifierName')}}
    brandName: '品牌名称',
    tradeAllNum: '交易总数',
    totalNum: '总数量',
    totalWeight: '总重量',
    destination: '目的港',//this.$t('tableHeader.destination')
    ranking: '排名',
    HSdescription: 'HS描述',
    times: '次数',
    subAccount: '子账户',
    focusTime: '关注时间',
    subscribe: '订阅',
    exclusive: '独享',
    tradeNumT: '交易数',
    // viewDetails: '查看详情',
    viewDetails: '查看',
    yisou: '易搜邮',
    cancelView: '取消子账户关注',
    tradeProd: '贸易产品',
    generationTime: '生成时间',
    downloadEnterprise: '下载企业',
    cancelAttention: '取消关注',
    exportFile: '导出文件',
    modifyLabel: '修改标签',
    enterprisesIncluded: '包含企业数量',
    actualDeduction: '实际扣点',
    downloads: '下载次数',
    downloadNew: '重新下载',
    exportFile: '导出文件',
    tradeNum: '包含交易条数',
    singleRecord: '单条记录',
    monthlyStatistics: '按月统计',
    AnnualStatistics: '按年统计',
    TradingYearOrMonth: '交易月份',
    TradingYear:'交易年份',
    month: '月份',
    amount:'金额',
    rate:'同比增长',
    enterpriseId: '企业ID',
    enterpriseCountry: '企业所在国',
    enterpriseMerge: '合并方'
  },
  // dashboard end
  // company result satrt
  resultHeader: {
    productKeywords: '产品关键词',
    hsCode: 'HS编码',
    companyName: '公司名称',
    searchCompany: '搜公司',//{{$t('resultHeader.searchCompany')}}
    queryData: '查数据',//{{$t('resultHeader.queryData')}}
    historicalSearch: '历史搜索',//{{$t('resultHeader.historicalSearch')}}
    advancedSearch: '高级搜索', //{{$t('resultHeader.advancedSearch')}}
    viewSearchHistory: '查看历史搜索'// {{$t('resultHeader.viewSearchHistory')}}
  },
  resultTop: {
    recommendedKeywords: '推荐关键词',//this.$t('resultTop.recommendedKeywords'),
    relevantHScode: '相关HS编码',//this.$t('resultTop.relevantHScode'),
    lenovoCompanyName: '联想公司名称',//this.$t('resultTop.lenovoCompanyName'),
    changeBatch: '换一批',
    displayEnglish: '显示英文',
    displayChinese: '显示中文',
    pleaseChoose: '请选择',//this.$t('resultTop.pleaseChoose'),
    have: '有',
    or: '与',
    individual: '个',
    of: '有关',
    addSmartList: '添加为商机列表',
    smartSort: '智能排序' // {{$t('resultTop.smartSort')}}
  },
  resultContain: {
    tradeTime: '交易时间',
    tradeTotal: '交易总量',
    consolidatedEnterprise: '合并企业',
    contMessage: '已包含联系信息',
    easyMail: '已易搜邮',
    easySearchMail: '易搜邮',
    easySearchMailNew:'易搜邮',
    concerned: '已关注',
    follow: '关注',
    Industry: '所属行业',
    latestTransactionDate: '最新交易日期',
    totalTransactionOrders: '总交易单数',
    numberOfRelatedPurchaseOrders: '相关采购单数',
    numberOfRelatedSuppliersOrders: '相关供应单数',
    secondaryCorrelation: '次相关',
    transactionHScode: '交易 HS 编码',
    lookMore: '查看更多',
    descriptionTradedGoods: '交易商品描述',
    websiteImg: '官网图片',
    supplier: '供应商',
    buyer: '对应产品采购商',
    buyerhave: '采购商归属',
    tradeProportion: '交易次数占比',
    newTradeTime: '最新交易时间',
    putAway: '收起',
    showAdditional: '显示另外',
    correspondingPurchaser: '家对应采购商',
    batchOperationEnterprise: '批量操作企业',
    selected: '您已选中',//{{$t('resultContain.selected')}}
    Enterprise: '家企业',//{{$t('resultContain.Enterprise')}}
    batchOperation: '批量操作',//{{$t('resultContain.batchOperation')}}
    selectallpage: '全选本页',
    deselectAll: '取消全选',
    batchSelection: '批量选择',
    batchAttention: '批量关注',
    exportEnterprise: '导出企业',// {{$t('resultContain.exportEnterprise')}}
    consolidatedEnterprise: '合并企业',// {{$t('resultContain.consolidatedEnterprise')}}
    chooseCorAdd: '选择国家/地区',// {{$t('resultContain.chooseCorAdd')}}
    findCountry: '输入国家名称查找', //:placeholder="$t('resultContain.findCountry')"
    mergeList: '合并企业列表',
    enterpriseScrip: '下列企业已经合并显示，企业操作只会影响您的查看与统计结果，并不会影响其他账户。您可以选择这些企业中的一个作为主企业，显示其名称。如果需要取消合并可点击删除。',
    mainEnterprise: '主企业',
    addTagSelf: '为关注企业添加自定义标签',
    advice: '为了您更方便的区分关注的企业，建议您为关注的公司，添加一个或多个自定义标签，例如用：日期、公司类型、产品名称等。',
    addTag: '添加标签',
    enter: '输入任意内容后回车',
    recommendedLabel: '推荐标签',
    aCostomer: 'A类客户',
    bCustorem: 'B类客户',
    dontAbout: '暂不关注',
    confirmAdd: '确认添加',
    Valueafter:'国家/地区后的数值',
    Numberof:'当前搜索条件下，该国家/地区的各数据类型的交易条数合计数量',
    numberoft:'采购商数量',
    ofsuppliers:'供应商数量',
  },
  companyResultsJS:{
    relatedCompany: '与公司名相关', // this.$t('companyResultsJS.relatedCompany')
    relatedDes: '与描述相关',
    relatedNum: '与税号相关',
    unlimitedBuy: '不限采购区域',
    onlyChina: '仅显示有中国采购经验',
    onlyChinaBuy: '从中国采购',
    enterpriseDirectory: '企业名录',
    tradeRole: '贸易角色', // this.$t('companyResultsJS.tradeRole')
    tradeRecord: '贸易记录',// this.$t('companyResultsJS.tradeRecord')
    tradeProducts: '贸易产品',// this.$t('companyResultsJS.tradeProducts')
    supplyAnalysis: '采供分析',// this.$t('companyResultsJS.supplyAnalysis')
    tradePort: '贸易港口',// this.$t('companyResultsJS.tradePort')
    businessInformation: '商业信息',// this.$t('companyResultsJS.businessInformation')
    contactInformation: '联系方式',// this.$t('companyResultsJS.contactInformation')
  },
  //leftFilter 组件
  leftFilter: {
    countryAndAddress: '国家和地区',
    allCountry: '全部国家',
    filter: '筛选',
    chooseTradeTime: '请选择交易时间限制',//:placeholder="$t('leftFilter.chooseTradeTime')"
    chooseTradeAddress: '请选择采购区域限制',  //:placeholder="$t('leftFilter.chooseTradeAddress')"
    excludeLogisticsCompanies: '排除物流企业',
    excludeBanks: '排除银行',//$t('leftFilter.excludeBanks')
    contactInformationIncluded: '已含联系方式',
  },
  // company result end
  // search start
  search: {
    search: '搜索',
    enterpriseList: '企业分布地区列表',
    tradeAddressList: '交易分布地区列表',
    flag: '国旗',
    multipleCompany: '多选国家',
    multipleCompanyTag: '多个国家',
    smartList: '商机列表',
    productDataTag: '产品数据标签',
    queryCountry: '查询国家/地区',//{{$t('search.queryCountry')}}
    selectCountry: '请选择国家/地区',//:placeholder="$t('search.selectCountry')"
    fuzzyQuery: '模糊查询',//{{$t('search.fuzzyQuery')}}
    preciseQuery: '精准查询',//{{$t('search.preciseQuery')}}
    hsQuery: '编码查询',//{{$t('search.hsQuery')}}
    filterRule: '筛选规则',//{{$t('search.filterRule')}}
    exclusionCategory: '排除类别',//{{$t('search.exclusionCategory')}}
    billLading: '提（运）单号',
    enterBill: '请输入提（运）单号',
    queryTool: '各国税号查询工具',
    translateChinese: '翻译为中文',
    filterQuery: '筛选查询', // :label="$t('search.filterQuery')"
    andSearch: '并搜索',//{{$t('search.andSearch')}}
    saveOther: '保存为',//{{$t('search.saveOther')}}
    clearAll: '清除所有条件',//{{$t('search.clearAll')}}
    searchResults: '搜索结果条数',//{{$t('search.searchResults')}}
    amountRange: '交易金额范围',//{{$t('search.amountRange')}}
    unitRange: '单价范围',//{{$t('search.unitRange')}}
    quantityRange: '数量范围',//{{$t('search.quantityRange')}}
    weightRange: '重量范围',//{{$t('search.weightRange')}}
    weightUnit: '重量单位',//{{$t('search.weightUnit')}}
    caseNumber: '箱号',//{{$t('search.caseNumber')}}
    enterCaseNumber: '请输入箱号',//:placeholder="$t('search.enterCaseNumber')"
    enterKeys: '请输入HS编码',//:placeholder="$t('search.enterKeys')"
    cusent:"唛头",
    cusentPlace:"请输入唛头",
    enterDescription: '请输入商品描述',//:placeholder="$t('search.enterDescription')"
    countryOriginD: '原产国(出口国)',//{{$t('search.countryOriginD')}}
    DestinationCountry: '目的国(进口国)',//{{$t('search.DestinationCountry')}}
    clearCriteria: '清空全部筛选条件',//{{$t('search.clearCriteria')}}
    editOpportunityList: '编辑商机列表',//this.$t('search.editOpportunityList')
    editProductTag: '编辑产品数据标签',//this.$t('search.editProductTag')
    smartBusinessOpportunities: '新增商机列表',//this.$t('search.smartBusinessOpportunities')
    newproductdatalabel:'新增产品数据标签',
  },
  //search end
  // company detail start
  companyDetail: {
    intervalDownData:'请填写需要下载数据的起止序号',// {{$t('companyDetail.intervalDownData')}}
    share:'分享',
    shareLink:'地址链接',
    shareCopy:'复制链接',
    downNumIndex:'下载序号范围：',
    dataChangeTime: '数据更新时间', //this.$t('companyDetail.dataChangeTime')
    search: '搜索公司',
    companyDetail: '公司详情',
    dataError: '数据纠错',
    productDataTag: '合并企业',
    wait: '等',
    individual: '个',
    selectImportType: '请选择进出口类型', //this.$t('companyDetail.selectImportType')
    sourceData: '请选择数据源',
    morefilter: '更多筛选',
    monthStart: '开始月份',
    monthEnd: '结束月份',
    supplyArea: '采供区域全景图',
    tradeRecord: '贸易记录',
    translate: '翻译',
    tradeProducts: '贸易产品',
    perspectiveImg: '采供链透视',
    supplierAnalysis: '供应商分析',//{{$t('companyDetail.supplierAnalysis')}}
    proportionSuppliers: '按企业',
    supplierDistribution: '按分布',
    purchaserAnalysis: '采购商分析',//{{$t('companyDetail.purchaserAnalysis')}}
    proportionPurchasers: '按企业',
    purchaserDistribution: '按分布',
    buyPortAnalysis: '采购记录港口分析',
    departure: '起运港/关区',//{{$t('companyDetail.departure')}}
    portD: '目的港/关区',//{{$t('companyDetail.portD')}}
    supplyPortAnalysis: '供应记录港口分析',
    businessInformation: '商业信息',
    IndustryCode: '行业编码类型',
    Industry: '所属行业',
    contactInformation: '联系方式',
    excavationTime: '上次挖掘时间',
    contactYiSou: '加为易搜邮联系人',
    cardShow: '卡片展示',
    tableShow: '表格展示',
    teYiContact: '特易全网挖掘联系人',
    moreContact: '更多联系人需使用【易搜邮】进行全网挖掘获取',
    openYisou: '启动易搜邮',
    contactService: '特易东盟实地联系服务',
    offlineGet: '东盟线下实体验证服务联系信息获取、采购商实地拜访...',
    applicationService: '申请服务',
    addTageSelf: '为了您更方便的区分关注的企业，建议您为关注的公司，添加一个或多个自定义标签，例如用：日期、公司类型、产品名称等。',
    addTag: '添加标签',
    showCont: '下列企业已经合并显示，企业操作只会影响您的查看与统计结果，并不会影响其他账户。您可以选择这些企业中的一个作为主企业，显示其名称。如果需要取消合并可点击删除。',
    mainEnterprise: '主企业',
    tradeData: '交易数据',//{{$t('companyDetail.tradeData')}}
    tradeDataDown: '下载交易数据',//{{$t('companyDetail.tradeDataDown')}}
    datachangeError: '数据纠错报告',
    replyEmail: '回复邮箱:',
    enterEmail: '请输入邮箱',//this.$t('companyDetail.enterEmail')
    enterEmailRight: '请输入正确的邮箱地址',//this.$t('companyDetail.enterEmailRight')
    contactPhone: '联系电话:',
    enterPhone: '请输入电话',
    questionDse: '问题描述:',
    pageDes: '请简要描述一下当前页面中，对于内容/数据的疑问。',
    countryAddList: '国家与地址列表',
    queryAdd: '地址查询',
    detailadd: '详细地址',
    intervalDownload: '区间下载',
    orderStart: '开始序号',
    orderEnd: '结束序号',
    companyDetailFilter: '公司详情页筛选',
    enterprise:'企业',
    Purchaser:'采购商',
    supplier:'供应商',
    Tradinggoods:'交易商品',
    Purchasetimes:'采购次数',
    Purchasegoods:'采购商品',
    Supplytimes:'供应次数',
    Supplygoods:'供应商品',
    second:'次',
    detailStatistics:'详细统计'
  },
  //company detail end
  // product  start
  productDetail: {
    //detail
    eotifier: '通知人',//{{$t('productDetail.eotifier')}}
    manufacturer: '制造商',//{{$t('productDetail.manufacturer')}}
    excludeNull: '排除采购商为空',
    supplNull: '排除供应商为空',
    chooseDeparture: '请选择起运港',
    chooseDestination: '请选择目的港',
    countryOrigin: '请选择原产国',
    countryDestination: '请选择目的国',
    marketTrendAnalysis: '市场趋势分析',//{{$t('productDetail.marketTrendAnalysis')}}
    exportProportion: '进出口占比',
    departureAnalysis: '起运港口分析',//{{$t('productDetail.departureAnalysis')}}
    switchModify: '修改/切换HS',
    switchProduct: '修改/切换产品HS编码',
    //Product
    productAnalysis: '产品分析报告',
    createAnalysis: '创建一个产品分析',
    tradeIntelligence: '贸易情报数据产品分析',
    createdProductA: '创建产品分析',
    importExportType: '进出口类型',//{{$t('productDetail.importExportType')}}
    countryChoice: '国家选择',
    chooseCountry: '请选择国家',
    productKey:'产品关键词',//{{$t('productDetail.productKey')}}
    enterHScode: '输入产品HS编码',
    openCode: '已开通行业的HS编码范围如下',
    pleaseEnterkeyWord: '请输入关键词',//{{$t('productDetail.pleaseEnterkeyWord')}}
    countryScreening: '数据国筛选',//{{$t('productDetail.countryScreening')}}
    Targetcountry:'目标国家或地区位置',
    Productname:'产品名称与行业类型',
    Purchaserand:'采购商与供应商条件',
    Logisticsrelated:'物流相关筛选条件',
    Commodityvolume:'商品量价筛选条件',
  },
  //product end
  //trade  start
  tradeData: {
    tradeDetail: {
      tradeIntelligence: '贸易情报',
      IntelligenceDetail: '贸易情报详情',
      dataChange: '数据纠错',
      print: '打印',
      fieldDescription: '字段说明',
      correctionReport: '数据纠错报告',
      changeOld: '切换旧版',
      intelligenceList: '情报列表', // this.$t('tradeData.tradeDetail.intelligenceList')
      marketTrendAnalysis: '市场趋势分析',//this.$t('tradeData.tradeDetail.marketTrendAnalysis')
      share: '分享',
    },
    tradeResult: {
      productDescription: '商品描述',//{{$t('tradeData.tradeResult.productDescription')}}
      portAnalysis: '目的港口分析',//{{$t('tradeData.tradeResult.portAnalysis')}}
      averagePriceA: '均价分析',//{{$t('tradeData.tradeResult.averagePriceA')}}
      brandAnalysis: '品牌分析',//{{$t('tradeData.tradeResult.brandAnalysis')}}
      CountryAanalysis: '国家/地区分析',//{{$t('tradeData.tradeResult.CountryAanalysis')}}
      findHave: '，找到有',
      displayColumn: '显示列',//{{$t('tradeData.tradeResult.displayColumn')}}
      customTable: '自定义列',//{{$t('tradeData.tradeResult.customTable')}}
      addTradeTag: '添加为贸易数据标签',//{{$t('tradeData.tradeResult.addTradeTag')}}
      Transactions: '条交易记录',//{{$t('tradeData.tradeResult.Transactions')}}
      advancedSearchCriteria: '高级搜索条件',//{{$t('tradeData.tradeResult.advancedSearchCriteria')}}
      searchCriteria: '搜索条件',//{{$t('tradeData.tradeResult.searchCriteria')}}
      throughYour: '通过您的',//{{$t('tradeData.tradeResult.throughYour')}}
      enterLableName: '请输入标签名称',//{{$t('tradeData.tradeResult.enterLableName')}}
      importdata:'（当前进口数据，分析内容为出口国或原产国）',
      exportdata:'（当前出口数据，分析内容为进口国或目的国）',
      Fullscreen:"全屏",
      FullscreenExit:"退出全屏",
    }
  },
  //trade  end
  //trend
  trendAnalysis: {
    TrendAnalysis: '趋势分析报告',
    markete: '市场',
    CreateMarketTrends: '创建市场趋势',
    SelectType: '选择类型',
    ExclusiveToChina: '中国专属',
    MarketDimension: '市场维度',
    IndustryDimension: '行业维度',
    SelectproductHScode: '选择产品HS编码',
    ImportAnd: '进出口选择',
    Export: '出口',// this.$t('trendAnalysis.Export')
    Importexport: '进出口',
    dataTime:'日期',// this.$t('trendAnalysis.dataTime')
    Import: '进口',// this.$t('trendAnalysis.Import')
    ImportAndExport:'进出口',
    SelectCountry: '选择国家',
    PleaseSelectACountry: '请选择国家',
    PleaseSelectType: '请选择类型',
    PleaseSelectHS: '请选择HS编码产品',
    CreatedSuccessfully: '创建成功',
    ThisAccountHas: '本账号无权限创建',
    YourTrendAnalysis: '您的趋势分析报告已达到创建上限',
    ThisOperation: '此操作将删除该分析报告，是否继续?',
    DeleteSucceeded: '删除成功',
    ThisAccount: '本账号无权限删除',
    china: {
      DataPhase: '数据时段',
      ReportView: '报告视图',
      dataTime:'日期',
      formView: '表格视图',
      DataType: '数据类型', // this.$t('trendAnalysis.china.DataType')
      TrendAnalysis: '趋势分析',
      EntranceArea: '进口区域',
      DuringtheabovePeriod: '在上述时段内',
      FirstlargestinletArea: '第一大进口区域',
      Oftotalimports: '占全部进口总量的',
      Thelargest: '第一大进口国家/地区',
      Oftotalimportsp: '占到全部进口总量的',
      Thesecond: '排名第二至第五位的分别为',
      Regional: '进口区域分布',
      Downloadpictures: '下载图片',
      Exportarea: '出口区域',
      Thelargests: '第一大出口区域',
      Oftotalexports: '占全部出口总量的',
      Thelargestexport: '第一大出口国家/地区',
      Oftotalexportsp: '占到全部出口总量的',
      Thesecondto: '排名第二至第五位的分别为',
      Exportregional: '出口区域分布',
      Importmarket: '进口市场动态',
      Growth: '增长值类型',
      Duringthe: '在上述时段内',
      Thefirstcountry: '进口正增长国家/地区第一',
      Thefirscountrynegative: '进口负增长国家/地区第一',
      negativegrowth: '负增长',
      increase: '增长',
      Thesecondtofifth: '排名第二至第五位的分别为',
      Byincreasedamount: '按增长金额',
      Bypercentagegrowth: '按增长百分比',
      Byproportion: '按占比',
      Bytotalamount: '按总金额',
      linear: '线性',
      exportmarketdynamics: '出口市场动态',
      typesofValueAdded: '增长值类型',
      Duringtheabove: '在上述时段内',
      Countrieswith: '出口正增长国家/地区第一',
      Firstcountry: '出口负增长国家/地区第一',
      Thesecondtofifthplaces: '排名第二至第五位的分别为',
      Trademarket: '贸易市场份额趋势',
      Graphictype: '图形类型',
      Yaxis: 'Y轴取值',
      Theright: '右图为',
      theabove: '在上述时段内',
      Globaltrademarket: '在上述时间段内的全球贸易市场份额趋势。',
      ModeofTrade: '贸易方式',
      Thelargestmode: '最大的贸易方式为',
      to: '至',
      switchModify: '修改/切换HS',
      switchproduct:'修改/切换产品HS编码',
      Pleaseenter:'请输入HS编码',
      Trenddetails:'趋势详情-趋势分析-外贸资讯宝GT6.0',
      Unsubscribe:'取消订阅成功',
      Subscription:'订阅成功',
      Modified:'修改成功',
      splyGrowth:'同比增长',
      increase:'增长量',
      total:'总量',
      TradeCities:'贸易城市'
    },
    industry: {
      EntranceArea: '进口区域',
      DataPhase: '数据时段',
      DuringtheabovePeriod: '在上述时段内',
      TrendAnalysis: '趋势分析',
      FirstlargestinletArea: '第一大进口区域',
      Thelargest: '第一大进口国家/地区',
      Oftotalimports: '占全部进口总量的',
      Oftotalimportsp: '占到全部进口总量的',
      Thesecond: '排名第二至第五位的分别为',
      Exportarea: '出口区域',
      Thelargests: '第一大出口区域',
      Thelargestexport: '第一大出口国家/地区',
      Oftotalexports: '占全部出口总量的',
      Oftotalexportsp: '占到全部出口总量的',
      Importmarket: '进口市场动态',
      typesofValueAdded: '增长值类型',
      Byincreasedamount: '按增长金额',
      Bypercentagegrowth: '按增长百分比',
      Byproportion: '按占比',
      Bytotalamount: '按总金额',
      linear: '线性',
      Thefirstcountry: '进口正增长国家/地区第一',
      Thefirscountrynegative: '进口负增长国家/地区第一',
      negativegrowth: '负增长',
      increase: '增长',
      Trademarket:'贸易市场份额趋势',
      exportmarketdynamics:'出口市场动态',
      Countrieswith:'出口正增长国家/地区第一',
      Firstcountry:'出口负增长国家/地区第一',
      Graphictype:'图形类型',
      Yaxis:'Y轴取值',
      Theright :' 右图为机器和',
      Globaltrademarket:'在上述时间段内的全球贸易市场份额趋势。通过各国的进口统计数据分析得出',
      tradebalance:'贸易平衡',
      Countries:'顺差最大国家/地区',
      difference:'差额',
      Countriesregions:'逆差最大国家/地区',
      Tradebalance:'贸易平衡分布图',
      NorthAmerica:'北美洲',
      SouthAmerica:'南美洲',
      Asia:'亚洲',
      Europe:'欧洲',
      Africa:'非洲',
      Oceania:'大洋洲'
    },
    market:{
      trendanalysis:'趋势分析',
      markettrends:'市场趋势',
      international:'国际贸易统计数据市场趋势',
      Internationaltrade:'国际贸易市场趋势',
      Tradetype:'贸易类型',
      dataphase:'数据时段',
      Industrytype:'行业类型',
      Displaydata:'展示数据',
      theright:'右图为',
      Thetrendof:'在上述时间段内的进出口贸易趋势，以及对应时间段内同比趋势对比。',
      markettrendst:'贸易市场趋势',
      change: '切换',
      Importand:'进出口产品情况',
      Classification:'分类方式',
      Largest:'第一大',
      product:'产品',
      oftotalimports:'占全部进口总量的',
      thelargest:'第一大进口来源国家/地区',
      thesecond:'排名第二至第五的分别为',
      Product:'产品分布',
      Sourcecountry:'来源国家/地区分布',
      Regionaltrend:'进出口区域趋势',
      Importsource:'进口来源国家/地区',
      Thesecondto:'排名第二至第五位增长国家/地区分别为',
      increase:'增长',
      DistributionMap:'进口来源国分布图',
      Downloadpictures: '下载图片',
      Import:'进口',
      Export:'出口',
      Byamount:'按金额',
      Bygrowth:'按增长',
      Byshare:'按份额',
      HS2bit:'HS 2位分类',
      HS4bit:'HS 4位分类',
      HS6bit:'HS 6位分类',
      HS8bit:'HS 8位分类',
      HS10bit:'HS 10位分类',
      whole:'全部',
      Nationaltax:'各国税号查询工具',
      Pleaseenter:'请输入关键词',
      Unsubscribe:'取消订阅成功',
      Subscription:'订阅成功',
      to:'至',
      ImpProductdistribution:'进口产品分布',
      ImpCountryoforigin:'进口来源国家/地区分布'
    },
  },
  analysisReport: {
    open:'已开通'
  },
  // trend result end
  // 调整时间段提示
  dataSource: {
    AdjustmentPeriod: '调整时段查看',
    from: '当前查询条件，可在此数据源的 ',
    to: '至',
    details1: '时段内，查询',
    details: '条结果。'
  }
}
